export { HeaderGiftTicket } from './HeaderGiftTicket';
export { BodyGiftTicket } from './BodyGiftTicket.jsx';
export { FooterGiftTicket } from './FooterGiftTicket.jsx';
